<template>
  <ValidationObserver ref="userLoginForm">
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="container">
       <div class="row justify-content-center">
  
            <div class="form-wraapper-inner">
              <h2>Passwort vergessen?</h2>
              <p>Bitte geben Sie Ihre E-Mail ein um einen Anmelde-Code zu erhalten.</p>

              <div v-if="formErr" role="alert" class="alert alert-danger">
                <div class="alert-text">{{ formErr }}</div>
              </div>
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Email is required.',
                }"
              >
                <v-text-field
                  autocomplete="new-password"
                  v-model="form.email"
                  :error-messages="errors[0]"
                  label="Email"
                  outlined
                ></v-text-field>
              </ValidationProvider>

              <v-btn
                type="submit"
                ref="kt_form_submit_btn"
                class="submit-btn-fill-color mt-3"
                :disabled="isDisabled"
              >
                {{ btnText }}
              </v-btn>
              <div class="signin">
                <p><router-link to="/">Zurück zum Login.</router-link>.</p>
              </div>
            </div> 

                        <div class="col-md-12 go-to-home-page mt-8 text-center"> 
                <a href="https://marktplatzgenius.lcmx.at">
                <v-btn depressed class="outline-button"><b-icon icon="arrow-left" class="mr-3" ></b-icon>Zurück zur Startseite</v-btn>
                </a>
          </div>

        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import { FRONTEND_LOGIN } from "@/core/services/store/auth.module";

export default {
  name: "ForgotPassword",
  data() {
    return {
      btnText: "Abschicken",
      btnDisable: false,
      form: {
        email: "",
      },
      formErr: null,
    };
  },
  methods: {
    onSubmit() {
      this.formErr = null;
      this.$refs.userLoginForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.btnText = "Wird abgeschickt...";
          axios
            .post("forgot-password", { email: this.form.email })
            .then((response) => {
              var responseJson = response.data;
              if (responseJson.status == "success") {
                this.btnDisable = false;
                this.btnText = "Abschicken";
                this.$router.push({
                  name: "code-verification",
                  query: { email: this.form.email },
                });
              } else {
                this.btnDisable = false;
                this.btnText = "Abschicken";
                this.formErr = responseJson.message;
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.btnText = "Abschicken";
              this.formErr = err;
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isFrontendAuthenticated", "frontendUser"]),
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>